<template>
  <div
    class="modal fade"
    :id="id"
    tabindex="-1"
    role="dialog"
    aria-labelledby="sizeChartModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal" role="document">
      <div class="modal-content">
        <div class="text-center py-2">
          <h5 class="font-weight-bold">CVO Size Chart</h5>
        </div>
        <div class="modal-body" style="overflow:hidden">
          <div class="table-responsive">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>Size</th>
                  <th>Men</th>
                  <th>Women</th>
                  <th>Kids</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <b>Petite</b>
                  </td>
                  <td></td>
                  <td>50</td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <b>Small</b>
                  </td>
                  <td>53</td>
                  <td>50-52</td>
                  <td>44-45</td>
                </tr>
                <tr>
                  <td>
                    <b>Medium</b>
                  </td>
                  <td>53-54</td>
                  <td>53-54</td>
                  <td>46-47</td>
                </tr>
                <tr>
                  <td>
                    <b>Large</b>
                  </td>
                  <td>55-56</td>
                  <td></td>
                  <td>48-51</td>
                </tr>
                <!-- <tr>
                  <td>
                    <b>StyleN Fit</b>
                  </td>
                  <td></td>
                  <td>55+</td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <b>XL</b>
                  </td>
                  <td>57+</td>
                  <td></td>
                  <td></td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary size-close"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SizeChartModal",
  props: {
    id: { type: String, default: "sizeChartModal" }
  },
  methods: {
    show() {
      $("#" + this.id).modal("show");
    }
  }
};
</script>
